<template>
  <div id="pageNotFound">
    <div class="desc">
      <div class="header">
        <span> {{$t('label.sorry')}} </span>
        <span>{{$t('label.somethingWentWrong')}}</span>
      </div>
      <div class="body">
        {{$t('label.PleaseTryAgainOrHeadBackToTheHomepage')}}
      </div>
    </div>
  </div>
</template>
<script src="./page-not-found.js"></script>
<style lang="scss" src="./page-not-found.scss"></style>
